import { getCurrentUser } from "aws-amplify/auth";
import type { Session } from "../types";

export async function getSession(): Promise<Session | null> {
  try {
    const user = await getCurrentUser();
    return { userId: user.userId, username: user.username };
  } catch {
    return null;
  }
}
